<template>
	<div class="main">
		<div class="ss">
			<view style="padding: 16upx 0%;">
					<uni-steps :options="list1" active-color="#fd8b4d" :active="active" />
			</view>
		</div>


		<div class="top">
			<div class="information">
				<div class="information_imag"><img class="information_img" src="../../static/images/ym/dingwei.png"
						alt=""></div>
				<div class="information_adr">
					<div class="information_addre">请选择体检人信息</div>
					<div class="information_time">根据您的信息为您定制最优质的服务</div>
				</div>
			</div>
			<p class='line'></p>
			<div class="address">
				<div class="imag"><img class="img" src="../../static/images/ym/dingwei.png" alt=""></div>
				<div class="adr">
					<div class="addre">爱康国宾西安曲江分院</div>
					<div class="time">预约时间 <span class="alltime"> 2022-11-15 08:00-10:30</span></div>
				</div>
			</div>
		</div>

		<div class="demand">
			<img class="demand_img" src="../../static/images/ym/jh.png" alt="">
			<div class="">空余位置紧张，请按时就医</div>
		</div>

		<div class="quan_a">
			<div class="quan_zi">【双11限定】乐享健康体检套餐(男)</div>
			<div class="quan_dy">￥1219.00</div>
		</div>

		<div class="quan">
			<div class="zi">每满减</div>
			<div class="dy" style="color:#dd9b6f ;">-￥120.00</div>
		</div>

		<div class="quan">
			<div class="zi">优惠券</div>
			<div class="dy">无可用 <img class="quan_img" src="../../static/youjiantou2.png" alt=""></div>
		</div>


		<div class="plan">
			<div class="title">加入爱康低碳环保计划</div>
			<div class="plan_cen">
				倡导低碳环保，远离污染，营造健康环境，爱康在行动！如您愿意选
				择查看电子版报告，放弃纸质报告，爱康将替您拥赠公益或颗外赠送
				您检测项目：
			</div>
			<view class="rido">
				<uni-data-checkbox v-model="value" :localdata="range "></uni-data-checkbox>
				<div class="rido_cent">
					爱康将为每位客户捐赠价值5,000元保题给乡村儿童大病医保公益基金，
				</div>
			</view>

		</div>

		<div class="bottom">
			<button class="bottom_btn" @click="go">上一步</button>
			<div class="allList">
				<div class="active">
					<div class="all">合计</div>
					<div class="allpic">￥1099.00</div>
				</div>

				<div class="choice">选择加项0项.升级项0项</div>
			</div>
			<button class="bottom_btn">下一步</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 2,
				value: 0,
				range: [{
						"value": 0,
						"text": "捐赠儿童公益一免纸质报告赠项 "
					},
					{
						"value": 1,
						"text": "血清钙(C)-免纸质报告赠送专用，本次体检即可使用"
					},
				],
				list1: [{
					title: '选择分院'
				}, {
					title: '选择加项'
				}, {
					title: '确认信息'
				}, ]
			}
		},

		methods: {
			change() {
				if (this.active < this.list1.length - 1) {
					this.active += 1
				} else {
					this.active = 0
				}
			},

			go() {
				uni.navigateBack({
					url: '/pages/hot/hot'
				})
			}
		}

	}
</script>

<style lang="scss">
	.main {
		height: 1380rpx;
		background-color: #f2f4f3;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.ss {
		height: 100rpx;
		width: 100%;
		background-color: #fff;
		margin-bottom: 20rpx;
	}

	.top {
		width: 720rpx;
		height: 300rpx;
		background-color: #fff;
		margin: 0rpx 20rpx;
		margin-bottom: 10rpx;
		border-radius: 15rpx;
	}

	.information {
		line-height: 60rpx;
		display: flex;
		align-items: center;
	}

	.information_imag {
		width: 75rpx;
		height: 75rpx;
		margin-right: 10rpx;
		margin-left: 15rpx;
	}

	.information_img {
		width: 75rpx;
		height: 75rpx;
	}

	.information_addre {
		font-size: 16px;
		font-weight: 600;
	}

	.information_time {
		font-size: 12px;
		color: #868686;
	}

	.line {
		width: 90%;
		height: 2rpx;
		background-color: #eee;
		margin: 0 auto;
	}

	.address {
		line-height: 60rpx;
		display: flex;
		align-items: center;
		margin-top: 20rpx;
	}

	.imag {
		width: 75rpx;
		height: 75rpx;
		margin-right: 10rpx;
		margin-left: 15rpx;
	}

	.img {
		width: 75rpx;
		height: 75rpx;
	}

	.addre {
		font-size: 16px;
		font-weight: 600;
	}

	.time {
		font-size: 14px;
		color: #868686;
	}

	.alltime {
		color: #fd8b4d;
	}

	.demand {
		width: 720rpx;
		background-color: #fff6e5;
		font-size: 28upx;
		height: 50upx;
		line-height: 50upx;
		display: flex;
		margin: 0upx 15upx;
	}

	.demand_img {
		width: 30upx;
		height: 30upx;
		margin: 10upx 15upx;
	}

	.quan_a {
		width: 720rpx;
		height: 90rpx;
		line-height: 80rpx;
		display: flex;
		margin: 20rpx 15rpx;
		background-color: #fff;
		border-radius: 15rpx;
	}

	.quan_zi {
		margin-left: 20rpx;
		font-size: 30rpx;
	}

	.quan_dy {
		font-size: 30rpx;
		color: #fd8b4d;
		margin-left: 60rpx;
	}

	.quan {
		width: 720rpx;
		height: 90rpx;
		line-height: 80rpx;
		display: flex;
		margin: 20rpx 15rpx;
		background-color: #fff;
		border-radius: 15rpx;
	}

	.zi {
		margin-left: 40rpx;
		font-size: 32rpx;
	}

	.dy {
		font-size: 30rpx;
		margin-left: 400rpx;
	}

	.quan_img {
		width: 30rpx;
		height: 30rpx;
		margin: 0rpx 10rpx;
	}

	.plan {
		width: 720rpx;
		height: 470rpx;
		margin: 10rpx 15rpx;
	}


	.title {
		font-weight: 600;
		font-size: 16px;
	}

	.plan_cen {
		font-size: 26rpx;
		color: #868686;
		margin: 10rpx 0rpx;
	}

	.rido {
		height: 140rpx;
		border: 1 solid red;
	}

	.rido_cent {
		font-size: 26rpx;
		color: #868686;
		margin: 15rpx 39rpx;
	}

	.bottom {
		display: flex;
		height: 85rpx;
	}

	.bottom_btn {
		margin: 0rpx;
		width: 160rpx;
		height: 85rpx;
		font-size: 25rpx;
		color: #FFF;
		background-color: #ff923b;
		border-radius: 0;
	}

	.allList {
		width: 410rpx;
		height: 74rpx;
		margin: 5rpx 20rpx;

	}

	.active {
		height: 36rpx;
		display: flex;
		font-size: 25rpx;
	}

	.all {
		line-height: 44rpx;
	}

	.allpic {
		font-size: 16px;
		font-weight: 600;
		color: #f36727;
	}

	.choice {
		font-size: 22rpx;
		margin-top: 6rpx;
		color: #868686;
	}
</style>
